<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component 
        :is="Component" 
        v-if="$route.meta.keepAlive" 
        :key="$route.name"
      />
    </keep-alive>
    <component 
      :is="Component" 
      v-if="!$route.meta.keepAlive" 
      :key="$route.name"
    />
  </router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}

</style>
